import { ELocalStorageKeys } from '@/lib/enums';
import { webStorageUtil } from '@/state/webStorage.state.service';

export const isStaleSessionAuthFailure = (error: unknown): boolean => {
  const requestToken = readBearerToken(error);
  const currentToken = webStorageUtil.getAny(ELocalStorageKeys.SESSION_TOKEN);

  if (requestToken === undefined || requestToken === '') {
    return false;
  }
  if (typeof currentToken !== 'string' || currentToken === '') {
    return false;
  }

  return requestToken !== currentToken;
};

const readBearerToken = (error: unknown): string | undefined => {
  const authorization = readAuthorizationHeader(error);
  if (authorization === undefined) {
    return undefined;
  }

  const bearerPrefix = 'Bearer ';
  if (!authorization.startsWith(bearerPrefix)) {
    return authorization;
  }

  return authorization.slice(bearerPrefix.length);
};

const readAuthorizationHeader = (error: unknown): string | undefined => {
  if (typeof error !== 'object' || error === null) {
    return undefined;
  }

  const config = (error as { config?: { headers?: unknown } }).config;
  const headers = config?.headers;
  if (headers === undefined || headers === null) {
    return undefined;
  }

  if (typeof (headers as { get?: unknown }).get === 'function') {
    const headerValue = (headers as { get: (name: string) => unknown }).get(
      'Authorization'
    );
    if (typeof headerValue === 'string') {
      return headerValue;
    }
    return undefined;
  }

  const namedHeaders = headers as {
    Authorization?: unknown;
    authorization?: unknown;
  };
  if (typeof namedHeaders.Authorization === 'string') {
    return namedHeaders.Authorization;
  }
  if (typeof namedHeaders.authorization === 'string') {
    return namedHeaders.authorization;
  }

  return undefined;
};
